import React, { useState } from 'react';

import Button from './Button';

const QuickActionFAB = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const quickActions = [
    {
      label: 'Nuevo Presupuesto',
      icon: 'FileText',
      action: 'create-quotation',
      color: 'primary'
    },
    {
      label: 'Agregar Producto',
      icon: 'Package',
      action: 'add-product',
      color: 'accent'
    },
    {
      label: 'Ajustar Stock',
      icon: 'Warehouse',
      action: 'adjust-stock',
      color: 'warning'
    }
  ];

  const handleActionClick = (action) => {
    setIsExpanded(false);
    
    switch (action) {
      case 'create-quotation': console.log('Navigate to create quotation');
        window.location.href = '/quotation-management?action=create';
        break;
      case 'add-product': console.log('Navigate to add product');
        window.location.href = '/product-catalog-management?action=create';
        break;
      case 'adjust-stock': console.log('Navigate to adjust stock');
        window.location.href = '/inventory-control?action=adjust';
        break;
      default:
        break;
    }
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="fixed bottom-6 right-6 z-floating lg:hidden">
      {/* Action Buttons */}
      {isExpanded && (
        <div className="absolute bottom-16 right-0 space-y-3">
          {quickActions.map((action, index) => (
            <div
              key={action.action}
              className="flex items-center justify-end space-x-3 animate-in slide-in-from-bottom-2 duration-200"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              {/* Label */}
              <div className="bg-surface px-3 py-2 rounded-lg shadow-card border border-border">
                <span className="text-sm font-body-medium text-text-primary whitespace-nowrap">
                  {action.label}
                </span>
              </div>
              
              {/* Action Button */}
              <Button
                variant={action.color}
                size="lg"
                shape="circle"
                onClick={() => handleActionClick(action.action)}
                className="shadow-floating"
                iconName={action.icon}
                iconSize={20}
              />
            </div>
          ))}
        </div>
      )}

      {/* Main FAB */}
      <Button
        variant="primary"
        size="xl"
        shape="circle"
        onClick={toggleExpanded}
        className="shadow-floating"
        iconName={isExpanded ? 'X' : 'Plus'}
        iconSize={24}
      />

      {/* Backdrop */}
      {isExpanded && (
        <div
          className="fixed inset-0 bg-black bg-opacity-25 -z-10"
          onClick={() => setIsExpanded(false)}
        />
      )}
    </div>
  );
};

export default QuickActionFAB;